import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';

import { 
	setModoTela, initFormItem, getListaItem, salvarItem, excluirItem, getListaTipo
 } from './lancamentoViagemActions';

import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndInputDate from '../common/form/labelAndInputDate';

class LancamentoViagemItem extends Component {

	state = {
		linhaSelecionada: null
	}

	componentWillMount() {
        
		this.props.getListaItem();
		this.props.getListaTipo();

		let idInterval = setInterval(() => {
			this.props.getListaItem();
			this.props.getListaTipo();
		}, 30000);
		
		this.setState({
			...this.state,
			idInterval: idInterval
		});
	}
	
	componentWillUnmount() {

		if (this.state.idInterval) {
			clearInterval(this.state.idInterval);
		}
	
    }

    render() {
		return (
			<>
				<Row alignCenter>
					<Grid cols='8 8 4 2' style={{ paddingRight: 20, marginBottom: 16 }}>
						<Button
							text='Adicionar Despesa / Receita'
							type={'success'}
							icon={'fa fa-plus'}
							event={() => {
								this.props.setModoTela('cadastro', {});
								this.props.initFormItem({ datahora_lancamento: DateFormat.getDataHoraAtual() });
							}} />
					</Grid>
				</Row>
				

				{this.props.lista.map(item => (
					<ContentCard key={item.id}
						onClick={() => {
							this.props.setModoTela('cadastro', {});
							this.props.initFormItem({ 
								...item,
								quantidade: FormatUtils.formatarValorTela(item.quantidade, 2),
                				valor: FormatUtils.formatarValorTela(item.valor, 2)
							});
						}}>
						<ContentCardBody>
							<Row>
								<Grid cols='12 12 12 12'>
									<p style={{ padding: 0, margin: 0, fontWeight: 'bold' }}>{item.nome_tipo}</p>
								</Grid>
							</Row>
							<Row>
								<Grid cols='6 6 6 6'>
									<p style={{ padding: 0, margin: 0, fontWeight: 'bold' }}>Data/Hora:</p>
								</Grid>
								<Grid cols='6 6 6 6'>
									<p style={{ padding: 0, margin: 0, fontWeight: 'bold', textAlign: 'right' }}>Valor:</p>
								</Grid>
							</Row>
							<Row>
								<Grid cols='6 6 6 6'>
								<p style={{ padding: 0, margin: 0 }}>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_lancamento)}</p>
								</Grid>
								<Grid cols='6 6 6 6'>
									<p style={{ padding: 0, margin: 0, textAlign: 'right', color: item.receita ? '#00328a' : '#bf0000' }}>R$ {FormatUtils.formatarValorTela(item.valor, 2)}</p>
								</Grid>
							</Row>
						</ContentCardBody>
					</ContentCard>
				))}
			</>
		);
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.lancamentoViagem.modoTela,
	aguardando: state.lancamentoViagem.aguardando,
	lista: state.lancamentoViagem.listaItem
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initFormItem, getListaItem, salvarItem, excluirItem, getListaTipo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(LancamentoViagemItem);